import { EventBus, TOOL_USE_EVENT } from '../common/EventBus'

export default class DownloadLink {
  constructor (element) {
    element.addEventListener('click', () => {
      EventBus.$emit(TOOL_USE_EVENT, element.href, 'Download: ' + element.href)
    })
  }
}
